import { Actions } from '../actions';

export type SessionReducerV1 = any;

export const initialSessionState: SessionReducerV1 = {};

const sessionReducer = (state = initialSessionState, action: Actions): SessionReducerV1 => {
    return state;
    // switch (action.type) {
    //     default:
    //         return state;
    // }
};

export default sessionReducer;
